/**
 * Determines if the Credit Balance Refund button should be displayed
 * More details about the Account Card display states here:
 * https://syf-agile.atlassian.net/wiki/spaces/VIS/pages/110101074/Account+Display+States+for+Products+for+Peaks+Vista
 * @param accountSummaryData Optional AccountSummaryGetResponse from v2 account summary API
 * @param accessToCreditBalanceRefund Optional boolean indicating if an account has access to a credit balance refund
 * @param isCBRFeatureFlagEnabled Optional boolean which is necessary to show the credit balance refund
 * @returns boolean value to show/hide the CBR button
 */
var shouldShowCreditBalanceRefund = function (_a) {
    var accountSummaryData = _a.accountSummaryData, accessToCreditBalanceRefund = _a.accessToCreditBalanceRefund, isCBRFeatureFlagEnabled = _a.isCBRFeatureFlagEnabled, isRegistered = _a.isRegistered;
    if (!accountSummaryData)
        return false;
    var currentBalance = accountSummaryData.credit.currentBalance;
    var isNegativeCurrentBalance = Number(currentBalance) < 0;
    /**
     * Show CBR button when the account is registered and the below conditions apply
     * Current Balance = Negative balance
     * Akamai feature CBR feature flag is enabled
     * API /v1/utility/account-management/product/features accessToCreditBalanceRefund: true
     */
    return (isRegistered &&
        isNegativeCurrentBalance &&
        accessToCreditBalanceRefund &&
        isCBRFeatureFlagEnabled);
};
export default shouldShowCreditBalanceRefund;
//# sourceMappingURL=shouldShowCreditBalanceRefund.js.map